import {ValueObject} from '@s-ui/domain'

import {AggregateRatingStructuredDataSeoValueObject} from './AggregateRatingStructuredDataSeoValueObject.js'
import {GeoCoordinatesStructuredDataSeoValueObject} from './GeoCoordinatesStructuredDataSeoValueObject.js'
import {PostalAddressStructuredDataSeoValueObject} from './PostalAddressStructuredDataSeoValueObject.js'

/**
 * https://schema.org/AutoDealer
 */
export class AutoDealerStructuredDataSeoValueObject extends ValueObject {
  #address
  #aggregateRating
  #context = 'http://schema.org'
  #geo
  #image
  #name
  #telephone
  #type = 'AutoDealer'
  #url

  constructor({address, aggregateRating, geo, image, name, telephone, url}) {
    super()
    this.#address = address
    this.#aggregateRating = aggregateRating
    this.#geo = geo
    this.#image = image
    this.#name = name
    this.#telephone = telephone
    this.#url = url
  }

  static createFromPrimitives({address, aggregateRating, geo, image, name, telephone, url}) {
    return new AutoDealerStructuredDataSeoValueObject({address, aggregateRating, geo, image, name, telephone, url})
  }

  static createWithDefaultValues({config, dealer}) {
    const protocol = config.get('URL_PROTOCOL')
    const host = config.get('HOST_DOMAIN')

    return new AutoDealerStructuredDataSeoValueObject({
      address: PostalAddressStructuredDataSeoValueObject.createFromPrimitives({
        streetAddress: dealer.address,
        postalCode: dealer.postalCode,
        addressLocality: dealer.city
      }),
      aggregateRating: AggregateRatingStructuredDataSeoValueObject.createFromPrimitives({
        ratingValue: dealer.ratings?.average,
        ratingCount: dealer.ratings?.totalReviews
      }),
      geo: GeoCoordinatesStructuredDataSeoValueObject.createFromPrimitives({
        latitude: dealer.coordinates?.lat,
        longitude: dealer.coordinates?.lng
      }),
      image: dealer.storeImageUrls?.[0],
      name: dealer.name,
      ...(dealer.isActive ? {telephone: [dealer.phoneNumber]} : {}),
      url: `${protocol}${host}${dealer.stockPageUrl}`
    })
  }

  get baseSchema() {
    return {
      '@context': this.#context,
      '@type': this.#type,
      address: this.#address.value,
      geo: this.#geo.value,
      image: this.#image,
      name: this.#name,
      telephone: this.#telephone,
      url: this.#url
    }
  }

  get baseSchemaWithRatings() {
    return {
      '@context': this.#context,
      '@type': this.#type,
      address: this.#address.value,
      aggregateRating: this.#aggregateRating.value,
      geo: this.#geo.value,
      image: this.#image,
      name: this.#name,
      telephone: this.#telephone,
      url: this.#url
    }
  }

  get value() {
    return {
      '@context': this.#context,
      '@type': this.#type,
      address: this.#address.value,
      aggregateRating: this.#aggregateRating.value,
      geo: this.#geo.value,
      image: this.#image,
      name: this.#name,
      telephone: this.#telephone,
      url: this.#url
    }
  }
}
